// extracted by mini-css-extract-plugin
export default {"root":"AdminManagement_root__IpgwD"};